import { render, staticRenderFns } from "./simple_copy_button.vue?vue&type=template&id=26214df1"
import script from "./simple_copy_button.vue?vue&type=script&lang=js"
export * from "./simple_copy_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports